import api from "../../api/services/axiosService";
import { DOCTOR_TATVA, USER_MANAGEMENT, VOICE_RX } from "../../envConstants";

const baseUrl: any = { customBaseUrl: VOICE_RX, isVoice: true };
const generateDDxUrl: any = { customBaseUrl: DOCTOR_TATVA };
const getCreditBaseUrl: any = {
  customBaseUrl: USER_MANAGEMENT,
  isTShots: true,
};

export const transcribeInput = async function (body: any) {
  let res: any = {};
  try {
    res = await api.post(`/transcribe`, body, { ...baseUrl, isFormData: true });
  } catch (e) {
    console.error(e);
  }
  return res;
};

/**
 * Same service and request contract as `transcribeInput`, with a different model behind
 * it. Used as a fallback: `/transcribe` is backed by OpenAI, and when that upstream is
 * unreachable it answers every request with `rx: { error: true, message: "LLM error:
 * Connection error." }`, which takes Generate DDx down completely. `/gemini-transcribe`
 * returns an identical `rx` shape, so nothing downstream needs to know which one ran.
 */
export const transcribeInputViaGemini = async function (body: any) {
  let res: any = {};
  try {
    res = await api.post(`/gemini-transcribe`, body, {
      ...baseUrl,
      isFormData: true,
    });
  } catch (e) {
    console.error(e);
  }
  return res;
};

export const generateDDx = async function (body: any) {
  let res: any = {};
  try {
    res = await api.post(`/api/v1/ddx/generate`, body, generateDDxUrl);
  } catch (e) {
    console.error(e);
  }
  return res;
};

export const getDDxHistory = async function ({
  page,
  pageSize,
}: {
  page: number;
  pageSize: number;
}) {
  let res: any = {};
  try {
    res = await api.get(
      `/api/v1/ddx/history?page=${page}&limit=${pageSize}`,
      generateDDxUrl
    );
  } catch (e) {
    console.error(e);
  }
  return res;
};

export const getDDxHistoryById = async function (historyId: string) {
  let res: any = {};
  try {
    res = await api.get(`/api/v1/ddx/result/${historyId}`, generateDDxUrl);
  } catch (e) {
    console.error(e);
  }
  return res;
};

export const postFeedback = async function (body: any) {
  let res: any = {};
  try {
    res = await api.patch(`/api/v1/ddx/impression`, body, generateDDxUrl);
  } catch (e) {
    console.error(e);
  }
  return res;
};

export const getCredits = async function (b2cId: string) {
  let res: any = {};
  try {
    res = await api.get(
      `/user/tatva/ddx-credit?b2c=${b2cId}`,
      getCreditBaseUrl
    );
  } catch (e) {
    console.error(e);
  }
  return res;
};
